<template>
	<div id='dom' class="page">
		<!-- <Tip :tip="tip" /> -->
		<el-image class="ad_img" :src="require('../../../assets/ad_img.png')" fit="cover"/>
		<span>供应链商品接入过程：</span>
		<div class="step">
			<el-steps :active="3">
			  <el-step title="第1步" description="开设微唯宝供应链账号"></el-step>
			  <el-step title="第2步" description="获取APPKey"></el-step>
			  <el-step title="第3步" description="填写APPKey"></el-step>
			  <el-step title="第4步" description="在线选品"></el-step>
			  <el-step title="第5步" description="同步商品到库"></el-step>
			</el-steps>
		</div>
		<el-divider></el-divider>
		<div class="from_div">
			<el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="110px">
				<!-- <el-form-item label="供应链名称：" style="margin-bottom: 0px;">
					<span>www.douhuomall.com</span>
				</el-form-item>
				<el-form-item label="客服咨询：" style="margin-bottom: 10px;">
					<span>133 49505 8477</span>
				</el-form-item> -->
				<el-form-item label="APPKey：" prop="supply_app_id">
					<el-input class="input" v-model="form.supply_app_id" placeholder="请输入内容" clearable></el-input>
				</el-form-item>
				<el-form-item label="APPSecrete：" prop="supply_app_secret">
					<el-input class="input" v-model="form.supply_app_secret" placeholder="请输入内容" clearable></el-input>
				</el-form-item>
				<el-form-item label="预留手机号：" prop="supply_mobile">
					<el-input class="input" v-model="form.supply_mobile" placeholder="请输入内容" clearable></el-input>
				</el-form-item>
				<el-form-item label="供应链类型：" prop="supply_type">
					<el-select v-model="form.supply_type" placeholder="请选择活动区域">
					  <el-option label="微维宝供应链" value="wwb"></el-option>
					  <el-option label="礼品云供应链" value="gift"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<!-- <el-button @click="close">返回</el-button> -->
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		mapGetters
	} from 'vuex';
    import { settingSupply } from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		data() {
			return {
				tip: '在与供应链平台业务开通后，进行配置。',
                form: {
					supply_mobile: '',
					supply_app_id: '',
					supply_app_secret: '',
					supply_typ : ''
				},
                rules: {
                    supply_mobile: [
                        { required: true, message: '请输入供应链注册的手机号', trigger: 'blur' },
                        { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }
                    ],
                    supply_app_id: [{ required: true, message: '请输入供应链appkey', trigger: 'blur' },],
                    supply_app_secret: [{required: true, message: '请输入供应链appSecret', trigger: 'blur' }]
                }
			}
		},
		computed: {
			...mapGetters(['loginInfo']),
		},
		mounted() {
			this.$watermark.set(this.loginInfo.nick_name + '-' + this.loginInfo.phone.substr(this.loginInfo.phone.length-4), dom);
            this.getConfig();
		},
		methods:{
            getConfig() {
                settingSupply().then(res => {
                    if (res.code == 0 && res.data) {
                        this.form = res.data;
                    }
                }).catch(err => {})
            },

            //提交表单
			submitForm(form) {
                var that = this;
				this.$refs[form].validate((valid) => {
					if (valid) {
						settingSupply({...that.form}, 'post').then(res => {
                            if (res.code == 0) {
                                that.$message({ type: 'success', message: res.msg || '保存成功!' });
                            }else{
                                that.$message({ type: 'error', message: res.msg || '保存失败!' });
                            }
                        }).catch(err => {})
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		min-height: -webkit-fill-available;
	}
	
	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
	.ad_img{
		width: 100%;
		height: auto;
		margin: 20px 0;
	}
	.step{
		margin-top: 20px;
	}
	.el-step.is-horizontal{
		margin-right: 400px;
	}
	.from_div {
		margin-top: 20px;
		width: 100%;
	}
	.input {
		width: 200px;
	}
</style>